module.exports = __webpack_public_path__ + "static/media/marker-red.1f163eaf.svg";